import variables from '../../variables.module.scss';

const MuiAppBar = (breakpoints) => ({
  styleOverrides: {
    root: {
      boxShadow: 'none',
      container: {
        maxWidth: '1280px',
      },
      backgroundColor: variables.appBarBackgroundColor,
      minHeight: '95.58px',
      [breakpoints.down('customheadermobile')]: {
        minHeight: '60px',
      },
    },
  },
});

export default MuiAppBar;
